import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";

import { Content } from "../../../../../../../features/dashboard/empresas/editar/$id/components/EditCompanyContent";

export const Route = createFileRoute("/_private/dashboard/_base/empresas/editar/$id/modal")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <BaseEditCreateModal title="Editar Empresa" from="/dashboard/empresas/editar/$id">
      <Content />
    </BaseEditCreateModal>
  );
}
